import { PostCallNotes, Spinner, SpinnerWrapper } from '@streem/ui-react';
import { Prompt } from 'react-router-dom';
import { usePromptBeforeUnload } from '../../../../../hooks/use_prompt_before_unload';
import { recordElementClicked } from '@streem/analytics';

import { NotesProvider, useNotes } from '../../../../../hooks/use_notes';
import { useReadOnly } from '../../../../../hooks/use_read_only';

export function RoomNote(): JSX.Element {
    return (
        <NotesProvider>
            <RoomNoteView />
        </NotesProvider>
    );
}

export function RoomNoteView(): JSX.Element {
    const { readOnlyYn } = useReadOnly();
    const {
        currentlySavedMarkdown,
        noteFinalizedYn,
        needsSavingYn,
        loadedYn,
        onNoteUpdated,
        roomNoteCharLimit,
        saveMarkdown,
        sendNote,
        currentInputText,
        initializedYn,
        roomIdStr,
        sendNoteEnabledYn,
    } = useNotes();
    usePromptBeforeUnload(needsSavingYn);

    if (!loadedYn || !initializedYn) {
        return (
            <SpinnerWrapper height="19.625rem" data-testid="room-note-spinner-wrapper">
                <Spinner size="2rem" />
            </SpinnerWrapper>
        );
    }

    return (
        <>
            <PostCallNotes
                markdownPersistedToBackend={currentlySavedMarkdown}
                onSave={saveMarkdown}
                defaultTemplate={undefined}
                initialMarkdown={currentInputText}
                sendNote={sendNote}
                noteFinalizedYn={noteFinalizedYn}
                captureButtonClick={recordElementClicked}
                onNoteUpdated={onNoteUpdated}
                maxCharacters={roomNoteCharLimit}
                readOnlyYn={readOnlyYn}
                sendNoteEnabledYn={sendNoteEnabledYn}
                key={roomIdStr} // force re-render when room changes
            />
            <Prompt
                when={needsSavingYn}
                message="You are about to leave this page but have unsaved changes. Are you sure you want to exit this page?"
            />
        </>
    );
}
